<template>
  <div class="radio-button-group">
    <label v-for="(option, i) in options"
           :key="i"
           :class="{ active: option.value === selected }"
           class="radio-box">
      <input type="radio" :value="option.value" v-model="selected">
      <span class="radio" :class="{ active: option.value === selected }" />
      <span class="label-text">{{option.label}}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'PxRadioButton',
  props: {
    options: { type: Array, default: () => [] },
    value: String
  },

  computed: {
    selected: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../scss/vars";
  .radio-button-group {
    display: flex;
    align-items: center;

    &.active {
      color: #000;
    }

    .radio-box {
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;
      padding: 0;
      &:not(:last-child) {
        margin-right: $basic-padding * 1.5;
      }

      .radio {
        display: flex;
        align-items: center;
        justify-content: center;
        height: $basic-size / 2;
        width: $basic-size / 2;
        margin-right: $small-padding;
        background-color: transparent;
        border-radius: 50%;
        border: dashed 1px $px-color-grey-semi;

        &:after {
          content: "";
          width: 0; //$basic-size / 3;
          height: 0; //$basic-size / 3;
          border-radius: 50%;
          background: $px-color-grey;
          opacity: 0.7;
          transition: all 0.15s;
        }

        &.active {
          background: #fff;
          border-style: solid;
          &:after {
            width: $basic-size / 3;
            height: $basic-size / 3;
          }
        }
      }

      &:hover input ~ .radio {
        /*background-color: #fff;*/
      }

      input {
        position: absolute;
        opacity: 0;
        height: 0;
        width: 0;
        cursor: pointer;

        &:checked {
          & ~ .label-text {
            color: $px-color-blue-dark;
          }
        }
      }
    }
  }
</style>
